import React, { FC } from 'react';

import { Box, Card, CardContent } from '@mui/material';

import AuthorityProvidedFieldsDataEntry from './AuthorityProvidedFieldsDataEntry';
import WaterAuthoritySelectionDropdown from './WaterAuthoritySelectionDropdown';

import { BackflowJobGroup } from '../../model';

interface WaterAuthorityUpdatingFieldsProps {
  backflowJobGroup: BackflowJobGroup;
  fetchBackflowJobGroup: () => void;
}

const WaterAuthorityUpdatingFields: FC<WaterAuthorityUpdatingFieldsProps> = (props) => {
  const { backflowJobGroup, fetchBackflowJobGroup } = props;

  return (
    <Card>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <WaterAuthoritySelectionDropdown
            backflowJobGroup={backflowJobGroup}
            fetchBackflowJobGroup={fetchBackflowJobGroup}
          />
        </Box>
        <AuthorityProvidedFieldsDataEntry
          backflowJobGroup={backflowJobGroup}
          fetchBackflowJobGroup={fetchBackflowJobGroup}
        />
      </CardContent>
    </Card>
  );
};

export default WaterAuthorityUpdatingFields;
